import { Button, DialogContent, DialogTitle, List, TextField } from "@mui/material"
import { useState } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { useDialog } from "lib/@hooks/useDialog"
import { OkCancel } from "lib/@components/okCancel"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { getReviewProjects } from "../controller/get-review-projects"
import { ReviewProjectPickerRow } from "./review-project-picker-row"

export function useSelectReviewProject() {
    return useDialog(<SelectReviewProjectDialog />)
}

export function SelectReviewProjectDialog() {
    const [search, setSearch] = useState("")
    const [selectedProjectId, setSelectedProjectId] = useState("")
    const projects = getReviewProjects.useResults({}, withInitialValue(IS_LOADING))
    const filteredProjects = filterProjects()
    const selectedProject = findSelectedProject(projects, selectedProjectId)

    return (
        <Bound>
            <DialogTitle>Choose Review Project</DialogTitle>
            <DialogContent>
                <TextField
                    label="Search projects"
                    value={search}
                    onChange={handleSearchChange}
                    fullWidth
                    sx={{ mt: 1, mb: 2 }}
                />
                {renderProjects()}
            </DialogContent>
            <OkCancel value={selectedProject} okCaption="Use Project">
                <Button onClick={handleClear}>Clear</Button>
            </OkCancel>
        </Bound>
    )

    function renderProjects() {
        if (projects === IS_LOADING) return <LoadingScreen />
        return (
            <List>
                <Repeat
                    list={filteredProjects}
                    item={
                        <ReviewProjectPickerRow selectedProjectId={selectedProjectId} onSelect={setSelectedProjectId} />
                    }
                />
            </List>
        )
    }

    function handleSearchChange(event) {
        setSearch(event.target.value)
    }

    function handleClear() {
        setSelectedProjectId("")
    }

    function filterProjects() {
        if (projects === IS_LOADING) return []
        const term = search.trim().toLowerCase()
        if (!term) return projects
        return projects.filter((project) => {
            const title = (project.title || "").toLowerCase()
            const description = (project.description || "").toLowerCase()
            return title.includes(term) || description.includes(term)
        })
    }

    function findSelectedProject(projects, selectedProjectId) {
        if (!selectedProjectId) return null
        if (projects === IS_LOADING) return null
        return projects.find(matchesSelectedProject) || null

        function matchesSelectedProject(project) {
            return project.id === selectedProjectId
        }
    }
}
